import * as React from "react";

// Components
import GoPlayHeader from "./GoPlayHeader";
import GoPlayToolBar from "./GoPlayToolBar";
import GoPlayMap from "./GoPlayMap";

// Libraries
import axios from "axios";

// Home
export default function Home() {

  // Map Reference
  const mapRef = React.useRef();

  // List of events, fetched from the API
  const [events, setEvents] = React.useState([]);

  // Count of Events used in Toolbar
  const [eventsCount, setEventsCount] = React.useState([]);

  // Load events data on page load
  React.useEffect(() => {

    // Load events data from the backend
    function fetchEvents() {
      axios.get(`${process.env.REACT_APP_API_URL}events/`).then((response) => {
        const responseEvents = response.data.results;
        const responseEventsCount = response.data.count;
        setEvents(responseEvents.filter((item) => item.approved));
        setEventsCount(responseEventsCount);
      });
    };

    fetchEvents();
  }, []);


  return (
    <div>
        <GoPlayHeader className="goplay-header"/>
        <GoPlayToolBar eventsCount={eventsCount} mapRef={mapRef}  className="goplay-toolbar"/>
        <GoPlayMap events={events} mapRef={mapRef} className="goplay-map"/>
    </div>
  );
}
